export default {"src":"/_next/static/media/icons8-facebook.548af54c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};